// extracted by mini-css-extract-plugin
export default {"content":"LiveCamera_content__Jk5GJ"};